import PDFBuilder, { fmtDate, fmtDateFromISO, formatCI } from "../../utils/pdfBuilder.js";

export default function buildActAditionalPDF(data, filename) {
  const pdf = new PDFBuilder();
  const today = fmtDate(new Date());

  // Title
  pdf.title(
    "Act Adițional",
    `la Contractul de Închiriere nr. ${data.numarContract || "___"} din data de ${fmtDateFromISO(data.dataContract)}`
  );

  // Intro date
  pdf.pMixed([
    { text: "Încheiat astăzi, " },
    { text: today, bold: true },
    { text: ", între:" },
  ]);

  // 1. Proprietarul
  pdf.section("1. Proprietarul");
  pdf.field("Nume", data.proprietarNume);
  pdf.field("CNP", data.proprietarCNP);
  pdf.field("CI seria", formatCI(data.proprietarCI) || "___ ___");
  pdf.field("Domiciliul", data.proprietarAdresa);

  // si
  pdf.italic("și");

  // 2. Chiriasul
  pdf.section("2. Chiriașul");
  pdf.field("Nume", data.chiriasNume);
  pdf.field("CNP", data.chiriasCNP);
  pdf.field("CI seria", formatCI(data.chiriasCI) || "___ ___");
  pdf.field("Domiciliul", data.chiriasAdresa);

  // Body intro
  pdf.pMixed([
    { text: "Părțile au convenit modificarea Contractului de Închiriere nr. " },
    { text: data.numarContract || "___", bold: true },
    { text: " din data de " },
    { text: fmtDateFromISO(data.dataContract), bold: true },
    { text: ", privind imobilul situat la adresa: " },
    { text: data.adresaImobil || "________________________", bold: true },
    { text: ", după cum urmează:" },
  ]);

  // Dynamic articles
  let articleNum = 1;

  if (data.prelungire) {
    const durata = data.prelungireNedeterminata
      ? "pe perioadă nedeterminată"
      : `până la data de ${data.nouaDataIncetare ? fmtDateFromISO(data.nouaDataIncetare) : "___________"}`;
    pdf.article(
      `Art. ${articleNum++}.`,
      `Durata contractului de închiriere se prelungește ${durata}.`
    );
  }

  if (data.modificareChirie) {
    const sumaVeche = data.chirieVeche || "___";
    const monedaVeche = data.chirieVecheMoneda || "EUR";
    const sumaNoua = data.chirieNoua || "___";
    const monedaNoua = data.chirieNouaMoneda || "EUR";
    const dataAplicare = data.dataAplicareChirie
      ? fmtDateFromISO(data.dataAplicareChirie)
      : "___________";
    pdf.article(
      `Art. ${articleNum++}.`,
      `Chiria lunară se modifică de la ${sumaVeche} ${monedaVeche} la ${sumaNoua} ${monedaNoua}, începând cu data de ${dataAplicare}.`
    );
  }

  if (data.modificareClauze) {
    pdf.article(
      `Art. ${articleNum++}.`,
      data.descriereModificare || "___________________________"
    );
  }

  // ANAF communication obligation (always present)
  pdf.article(
    `Art. ${articleNum++}.`,
    "Prezentul act adițional va fi comunicat organelor fiscale competente (ANAF) conform legislației în vigoare."
  );

  // Other clauses remain unchanged (always present)
  pdf.article(
    `Art. ${articleNum}.`,
    `Celelalte clauze ale Contractului de Închiriere nr. ${data.numarContract || "___"} din data de ${fmtDateFromISO(data.dataContract)} rămân nemodificate și în vigoare.`
  );

  // Closing
  pdf.p(
    "Prezentul act adițional s-a încheiat în 2 exemplare originale, câte unul pentru fiecare parte."
  );

  // Signatures
  pdf.signatures(
    { role: "PROPRIETAR", name: data.proprietarNume || "", date: today },
    { role: "CHIRIAȘUL", name: data.chiriasNume || "", date: today }
  );

  pdf.save(filename);
}
